// extracted by mini-css-extract-plugin
export default {"wrapper":"Wl_AdNDTCZHOFme9m9IN","user-details":"HwkyjzvEGFXyupPf62Sc","full-name":"K7seevUkxWkbFOtbDNnE"};